import { render, staticRenderFns } from "./TokenPasswordChangeView.vue?vue&type=template&id=04e0e405&scoped=true"
import script from "./TokenPasswordChangeView.vue?vue&type=script&lang=ts"
export * from "./TokenPasswordChangeView.vue?vue&type=script&lang=ts"
import style0 from "./TokenPasswordChangeView.vue?vue&type=style&index=0&id=04e0e405&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e0e405",
  null
  
)

export default component.exports